var _defs, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLevelBooster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_354_728",
    x1: 11.8403,
    y1: 20.8547,
    x2: 11.8983,
    y2: 13.4719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4163F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_354_728",
    x1: 11.8634,
    y1: 17.7788,
    x2: 11.8887,
    y2: 9.22298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4163F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_354_728",
    x1: 12.0118,
    y1: 16.7162,
    x2: 12.0118,
    y2: 2.68844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4163F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875EFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70167 9.62967L1.71404 14.7927C0.823419 15.3687 0.824728 16.6721 1.71622 17.2464L9.70778 22.3903C11.0129 23.2303 12.6881 23.2324 13.9955 22.3955L22.0364 17.2481C22.9322 16.6748 22.9335 15.3661 22.0385 14.7905L14.0016 9.624C12.6912 8.78182 11.0095 8.78356 9.70124 9.62923L9.70167 9.62967Z",
    fill: "url(#paint0_linear_354_728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.039 11.561L21.6227 11.2935L14.129 16.09C12.8217 16.927 11.1465 16.9248 9.84131 16.0848L2.26386 11.2076L1.7136 11.5632C0.822983 12.1392 0.824292 13.4426 1.71578 14.0169L9.70735 19.1607C11.0125 20.0007 12.6877 20.0029 13.9951 19.166L22.0359 14.0186C22.9318 13.4452 22.9331 12.1366 22.0381 11.561H22.039Z",
    fill: "url(#paint1_linear_354_728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8352 3.32422L1.848 8.48727C0.957382 9.06327 0.958691 10.3667 1.85018 10.9409L9.84175 16.0848C11.1469 16.9248 12.8221 16.927 14.1295 16.09L22.1703 10.9427C23.0662 10.3693 23.0675 9.06066 22.1725 8.48509L14.1356 3.31855C12.8252 2.47637 11.1434 2.47855 9.8352 3.32422Z",
    fill: "url(#paint2_linear_354_728)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.6009 11.2887L14.1434 16.0464C12.7575 16.9335 11.1312 16.937 9.74749 16.0464L2.26691 11.1949C2.26691 11.1949 1.85804 11.4633 1.86196 11.4716C1.90298 11.5554 2.00814 11.6304 2.18662 11.7452L9.27971 16.4335C10.0879 16.9536 11.0147 17.2137 11.942 17.2137C12.8649 17.2137 13.7878 16.9558 14.5937 16.44L21.6441 11.9145C21.8583 11.7775 21.9857 11.7399 22.0172 11.561C22.0189 11.5501 21.6013 11.2887 21.6013 11.2887H21.6009Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.4521 14.4052L14.0422 19.1201C12.6563 20.0073 11.03 20.0108 9.64626 19.1201L2.31622 14.3952C2.31622 14.3952 1.90735 14.6636 1.91127 14.6719C1.95229 14.7556 2.05746 14.8307 2.23593 14.9455L9.17847 19.5072C9.98662 20.0273 10.9135 20.2874 11.8407 20.2874C12.7636 20.2874 13.6865 20.0295 14.4925 19.5137L21.4948 15.031C21.7091 14.894 21.8365 14.8564 21.8679 14.6775C21.8697 14.6666 21.4521 14.4052 21.4521 14.4052Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1561 5.82764L9.34211 9.76975C9.27622 9.91288 9.38095 10.0761 9.53847 10.0761H11.0086C11.15 10.0761 11.2534 10.2096 11.2176 10.3462L10.4662 13.245C10.4095 13.464 10.6844 13.6119 10.8358 13.4439L15.1231 8.68714C15.25 8.54619 15.1466 8.32146 14.9568 8.3267L13.0625 8.37819C12.9059 8.38255 12.7968 8.22372 12.8575 8.07884L13.7433 5.96074C13.8035 5.81674 13.6957 5.65834 13.5399 5.66139L11.3489 5.70241C11.266 5.70415 11.1914 5.75259 11.1565 5.82808L11.1561 5.82764Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevelBooster);
export default __webpack_public_path__ + "static/media/icon-level-booster.779ede3247bea17ef23e37b72abb319a.svg";
export { ForwardRef as ReactComponent };